// import { assert } from '@/core';
import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './utils';

// This is a interface which extendds
export class UserService extends BaseService {
  static get entity() {
    return 'users';
  }

  // TimseZone helpers
  static async getTimeZone() {
    try {
      const response = await this.request({
        auth: true,
      }).get(`${this.entity}/timezones`);
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async updateTimeZone(data) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity}/timezones`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  // Password helpers
  static async passwordReset(data) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity}/password/reset`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async passwordUpdate(data) {
    try {
      const response = await this.request({ auth: true }).post(
        `${this.entity}/password`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  static async dashboardUpdate(data) {
    try {
      const response = await this.request({ auth: true }).put(
        `${this.entity}/profile`,
        data,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  //Get license token
  static async getOapAccessToken(id) {
    // this.entity = 'teams';
    try {
      const response = await this.request({ auth: true }).get(
        `teams/${id}/token/app`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  //profile  api to get user data
  static async getProfile(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `${this.entity}/profileDetails`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  //TODO : API calls will be updated with a single call post the necessary backend changes
  // api to get the user last 30 days login count
  static async getUserLoginCount(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `tokens/userLogin/count`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
  // api to get the user last login(including the current login)
  static async getUserLastLogin(id) {
    try {
      const response = await this.request({ auth: true }).get(
        `tokens/userLogin/lastLogin`,
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      const message = error.response.data
        ? error.response.data.error
        : error.response.statusText;
      throw new ErrorWrapper(error, message);
    }
  }
}
